export type SoapDraftClientTarget =
  | { kind: "appointment"; id: string; rdId?: string }
  | { kind: "session"; id: string };

export function soapDraftPath(target: SoapDraftClientTarget): string {
  const resource = target.kind === "appointment" ? "appointments" : "sessions";
  const path = `/api/${resource}/${encodeURIComponent(target.id)}/draft`;
  if (target.kind !== "appointment" || !target.rdId) return path;

  return `${path}?rdId=${encodeURIComponent(target.rdId)}`;
}

export function soapDraftTargetKey(target: SoapDraftClientTarget): string {
  return target.kind === "appointment"
    ? `${target.kind}:${target.id}:${target.rdId ?? "own"}`
    : `${target.kind}:${target.id}`;
}
